"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.query = exports.useOrdersHistory = exports.useBalance = exports.useGasPrice = exports.useFeeOnTransfer = exports.useMinNativeTokenBalance = void 0;
var web3_candies_1 = require("@defi.org/web3-candies");
var react_query_1 = require("@tanstack/react-query");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var react_1 = require("react");
var consts_1 = require("../consts");
var context_1 = require("../context/context");
var enums_1 = require("../enums");
var FEE_ON_TRANSFER_json_1 = __importDefault(require("../abi/FEE_ON_TRANSFER.json"));
var utils_1 = require("../utils");
var types_1 = require("../types");
var hooks_1 = require("./hooks");
var store_1 = require("../store");
var order_history_1 = require("../order-history");
var lib_1 = require("./lib");
var useMinNativeTokenBalance = function (minNativeTokenBalance) {
    var _a = (0, context_1.useTwapContext)(), web3 = _a.web3, account = _a.account, config = _a.config;
    var network = (0, hooks_1.useNetwork)();
    var key = ["useHasMinNativeTokenBalance", account, config.chainId, minNativeTokenBalance];
    var queryClient = (0, react_query_1.useQueryClient)();
    var query = (0, react_query_1.useQuery)(key, function () { return __awaiter(void 0, void 0, void 0, function () {
        var balance;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, web3.eth.getBalance(account)];
                case 1:
                    balance = _a.sent();
                    return [2 /*return*/, (0, bignumber_js_1.default)(balance).gte((0, utils_1.amountBNV2)(network === null || network === void 0 ? void 0 : network.native.decimals, minNativeTokenBalance))];
            }
        });
    }); }, {
        enabled: !!web3 && !!minNativeTokenBalance && !!account && !!config && !!network,
        staleTime: Infinity,
    });
    var ensureData = (0, react_1.useCallback)(function () {
        return queryClient.ensureQueryData(key);
    }, [queryClient, key]);
    return __assign(__assign({}, query), { ensureData: ensureData });
};
exports.useMinNativeTokenBalance = useMinNativeTokenBalance;
var useGetContract = function () {
    var web3 = (0, context_1.useTwapContext)().web3;
    return (0, react_1.useCallback)(function (abi, address) {
        if (!web3)
            return undefined;
        return new web3.eth.Contract(abi, address);
    }, [web3]);
};
var useFeeOnTransfer = function (tokenAddress) {
    var config = (0, context_1.useTwapContext)().config;
    var address = (0, react_1.useMemo)(function () {
        if (!config.chainId)
            return undefined;
        return consts_1.feeOnTransferDetectorAddresses[config.chainId];
    }, [config.chainId]);
    var network = (0, hooks_1.useNetwork)();
    var getContract = useGetContract();
    return (0, react_query_1.useQuery)({
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var contract, res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        contract = getContract(FEE_ON_TRANSFER_json_1.default, address);
                        if (!contract) {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, (contract === null || contract === void 0 ? void 0 : contract.methods.validate(tokenAddress, network === null || network === void 0 ? void 0 : network.wToken.address, consts_1.AMOUNT_TO_BORROW).call())];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, {
                                buyFee: res.buyFeeBps,
                                sellFee: res.sellFeeBps,
                                hasFeeOnTranfer: (0, bignumber_js_1.default)(res.buyFeeBps).gt(0) || (0, bignumber_js_1.default)(res.sellFeeBps).gt(0),
                            }];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        }); },
        queryKey: ["useFeeOnTransfer", tokenAddress, config.chainId, address],
        enabled: !!tokenAddress && !!config && !!address && !!network,
        staleTime: Infinity,
    });
};
exports.useFeeOnTransfer = useFeeOnTransfer;
var useGasPrice = function () {
    var _a = (0, context_1.useTwapContext)(), web3 = _a.web3, contextMax = _a.maxFeePerGas, contextTip = _a.priorityFeePerGas;
    var _b = (0, react_query_1.useQuery)([enums_1.QueryKeys.GET_GAS_PRICE, contextTip, contextMax], function () { return (0, web3_candies_1.estimateGasPrice)(undefined, undefined, web3); }, {
        enabled: !!web3,
        refetchInterval: consts_1.REFETCH_GAS_PRICE,
    }), isLoading = _b.isLoading, data = _b.data;
    var priorityFeePerGas = bignumber_js_1.default.max((data === null || data === void 0 ? void 0 : data.fast.tip) || 0, contextTip || 0);
    var maxFeePerGas = bignumber_js_1.default.max((data === null || data === void 0 ? void 0 : data.fast.max) || 0, contextMax || 0, priorityFeePerGas);
    return {
        isLoading: isLoading,
        maxFeePerGas: maxFeePerGas,
        priorityFeePerGas: priorityFeePerGas,
    };
};
exports.useGasPrice = useGasPrice;
var useAllowance = function () {
    var _a = (0, context_1.useTwapContext)(), srcToken = _a.srcToken, config = _a.config, account = _a.account;
    var srcAmount = (0, lib_1.useSrcAmount)().amount;
    var getHasAllowance = (0, hooks_1.useGetHasAllowance)();
    var query = (0, react_query_1.useQuery)([enums_1.QueryKeys.GET_ALLOWANCE, config.chainId, srcToken === null || srcToken === void 0 ? void 0 : srcToken.address, srcAmount], function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, getHasAllowance(srcToken, srcAmount)];
        });
    }); }, {
        enabled: !!srcToken && (0, bignumber_js_1.default)(srcAmount).gt(0) && !!account && !!config,
        staleTime: consts_1.STALE_ALLOWANCE,
        refetchOnWindowFocus: true,
    });
    return __assign(__assign({}, query), { isLoading: query.isLoading && query.fetchStatus !== "idle" });
};
var useBalance = function (token, onSuccess, staleTime) {
    var _a = (0, context_1.useTwapContext)(), web3 = _a.web3, account = _a.account;
    var query = (0, react_query_1.useQuery)([enums_1.QueryKeys.GET_BALANCE, account, token === null || token === void 0 ? void 0 : token.address], function () {
        (0, web3_candies_1.setWeb3Instance)(web3);
        if ((0, web3_candies_1.isNativeAddress)(token.address))
            return web3.eth.getBalance(account).then(bignumber_js_1.default);
        else
            return (0, web3_candies_1.erc20)(token.symbol, token.address, token.decimals).methods.balanceOf(account).call().then(bignumber_js_1.default);
    }, {
        enabled: !!web3 && !!token && !!account,
        onSuccess: onSuccess,
        refetchInterval: consts_1.REFETCH_BALANCE,
        staleTime: staleTime,
    });
    return __assign(__assign({}, query), { isLoading: query.isLoading && query.fetchStatus !== "idle" && !!token });
};
exports.useBalance = useBalance;
var useOrderHistoryKey = function () {
    var _a = (0, context_1.useTwapContext)(), config = _a.config, account = _a.account;
    return [enums_1.QueryKeys.GET_ORDER_HISTORY, account, config.exchangeAddress, config.chainId];
};
var useAddNewOrder = function () {
    var QUERY_KEY = useOrderHistoryKey();
    var queryClient = (0, react_query_1.useQueryClient)();
    var config = (0, context_1.useTwapContext)().config;
    return (0, react_1.useCallback)(function (order) {
        try {
            if (!config)
                return;
            store_1.ordersStore.addOrder(config.chainId, order);
            queryClient.setQueryData(QUERY_KEY, function (prev) {
                var updatedOpenOrders = (prev === null || prev === void 0 ? void 0 : prev.Open) ? __spreadArray([order], prev.Open, true) : [order];
                if (!prev) {
                    return {
                        Open: updatedOpenOrders,
                    };
                }
                return __assign(__assign({}, prev), { Open: updatedOpenOrders });
            });
        }
        catch (error) { }
    }, [QUERY_KEY, queryClient, config]);
};
var useUpdateOrderStatusToCanceled = function () {
    var QUERY_KEY = useOrderHistoryKey();
    var queryClient = (0, react_query_1.useQueryClient)();
    var config = (0, context_1.useTwapContext)().config;
    return (0, react_1.useCallback)(function (orderId) {
        try {
            store_1.ordersStore.cancelOrder(config.chainId, orderId);
            queryClient.setQueryData(QUERY_KEY, function (prev) {
                var _a;
                if (!prev)
                    return prev;
                return __assign(__assign({}, prev), (_a = {}, _a[types_1.Status.Open] = prev[types_1.Status.Open].map(function (o) {
                    if (o.id === orderId) {
                        return __assign(__assign({}, o), { status: types_1.Status.Canceled });
                    }
                    return o;
                }), _a));
            });
        }
        catch (error) {
            console.error(error);
        }
    }, [QUERY_KEY, queryClient, config]);
};
var useOrdersHistory = function () {
    var _a = (0, context_1.useTwapContext)(), tokens = _a.tokens, state = _a.state, config = _a.config, account = _a.account;
    var QUERY_KEY = useOrderHistoryKey();
    var getTokensFromTokensList = (0, hooks_1.useGetTokenFromParsedTokensList)();
    var query = (0, react_query_1.useQuery)(QUERY_KEY, function (_a) {
        var signal = _a.signal;
        return __awaiter(void 0, void 0, void 0, function () {
            var endpoint, orders, ids_1, chainOrders, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        endpoint = (0, utils_1.getTheGraphUrl)(config.chainId);
                        if (!endpoint) {
                            return [2 /*return*/, []];
                        }
                        return [4 /*yield*/, (0, order_history_1.getGraphOrders)(endpoint, account, signal)];
                    case 1:
                        orders = _b.sent();
                        try {
                            ids_1 = orders.map(function (o) { return o.id; });
                            chainOrders = store_1.ordersStore.orders[config.chainId];
                            chainOrders.forEach(function (o) {
                                if (!ids_1.includes(Number(o.id))) {
                                    orders.push(o);
                                }
                                else {
                                    store_1.ordersStore.deleteOrder(config.chainId, o.id);
                                }
                            });
                        }
                        catch (error) { }
                        (0, utils_1.logger)("all orders", orders);
                        orders = orders.filter(function (o) { return (0, web3_candies_1.eqIgnoreCase)(config.exchangeAddress, o.exchange || ""); });
                        (0, utils_1.logger)("filtered orders by exchange address", config.exchangeAddress, orders);
                        orders = orders.map(function (order) {
                            return __assign(__assign({}, order), { srcToken: getTokensFromTokensList(order.srcTokenAddress), dstToken: getTokensFromTokensList(order.dstTokenAddress) });
                        });
                        result = (0, utils_1.compact)(orders.filter(function (o) { return o.srcToken && o.dstToken; }));
                        result = (0, utils_1.orderBy)(result, function (o) { return o.createdAt; }, "desc");
                        result = (0, utils_1.groupBy)(result, "status");
                        return [2 /*return*/, result];
                }
            });
        });
    }, {
        enabled: !!config && (tokens === null || tokens === void 0 ? void 0 : tokens.length) > 10 && !state.showConfirmation && !!account,
        refetchInterval: consts_1.REFETCH_ORDER_HISTORY,
        onError: function (error) { return console.log(error); },
        refetchOnWindowFocus: true,
        retry: 5,
        staleTime: Infinity,
    });
    return __assign(__assign({}, query), { orders: query.data || {}, isLoading: query.isLoading && query.fetchStatus !== "idle" });
};
exports.useOrdersHistory = useOrdersHistory;
exports.query = {
    useFeeOnTransfer: exports.useFeeOnTransfer,
    useGasPrice: exports.useGasPrice,
    useMinNativeTokenBalance: exports.useMinNativeTokenBalance,
    useBalance: exports.useBalance,
    useOrdersHistory: exports.useOrdersHistory,
    useAllowance: useAllowance,
    useAddNewOrder: useAddNewOrder,
    useUpdateOrderStatusToCanceled: useUpdateOrderStatusToCanceled,
};
